module.exports = __webpack_public_path__ + "components/media-kit/static/icon-australasia-f8fde3109dbf9847c7b5b75376e884bd.svg";